/**
 * Normalize "request canceled" detection across fetch/axios/AbortController.
 *
 * We treat cancellation as non-error for UI flows (navigation away, new search, etc).
 */

export function isAbortError(err: unknown, abortSignal?: AbortSignal): boolean {
    if (abortSignal?.aborted) return true;

    if (!err || typeof err !== 'object') return false;
    const anyErr = err as any;

    // Standard DOM abort (fetch, AbortController)
    if (anyErr.name === 'AbortError') return true;

    // Axios v1 uses code=ERR_CANCELED; some environments use ERR_CANCELLED
    if (anyErr.code === 'ERR_CANCELED' || anyErr.code === 'ERR_CANCELLED') return true;

    // Fallback: message contains "canceled/cancelled" (covers some polyfills/wrappers)
    const msg = (anyErr.message ?? '').toString().toLowerCase();
    if (msg.includes('canceled') || msg.includes('cancelled') || msg.includes('cancel')) return true;

    return false;
}

